import O1HD from "../../../../../engines/gameEngine";
import ShopLotteryFFCManager from "./ShopLotteryFFCManager";
import ShopFFCSimplePrefab from "./ShopFFCSimplePrefab";
import ShopLotteryNewGGLPrefab from "./newGGL/ShopLotteryNewGGLPrefab";
import NormalGameManager from "../../../manager/NormalGameManager";
import gameConfig from "../../../../../engines/configs/gameConfig";
import { UIKind } from "../../../../define/UIKind";
import utilsView from "../../../../../engines/libs/utilsView";
import { FileKind } from "../../../../define/FileKind";
import { MahjongKind } from "../../lottery/mahjong/data/MahjongKind";
import { MingTangKind } from "../../lottery/mingTang/data/MingTangKind";
import utilsModel from "../../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

/**
 * 彩票中心
 */
@ccclass
export default class LotteryCenterPrefab extends cc.Component {

	@property({ type: cc.Label, displayName:'' })
	labelTalk: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTalk: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	touchNode: cc.Node = null;

    @property({type:cc.Prefab,displayName:"刮刮乐预制体"})
    lotteryGGLPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"分分彩预制体"})
    lotteryFFCPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"双色球机器"})
    lotteryMachinePrefab : cc.Prefab = null;

    @property(cc.Node)
    gglAdBtnNode : cc.Node = null;

    private mLotteryFFCManager : ShopLotteryFFCManager;
    private readonly ChineseZodiacArray : string[] = ['鼠','牛','虎','兔','龙','蛇','马','羊','猴','鸡','狗','猪'];
    private mGameLayer : NormalGameManager;


    private bOpenShip = false;
    /** 点击次数 */
    private touchCount = 0;
    // private prizeArray :  ;

    onLoad () {}

    start () {

        this.touchNode.active = false;
        this.nodeTalk.active = false;

        this.mGameLayer = NormalGameManager._instance;
        if ( !this.mGameLayer.getGameData().lotteryInfo ) {
            //初始化数据
            this.mGameLayer.getGameData().lotteryInfo = { gglValidCount : 0 , hjGGLValidCount : 0 ,currGGLPurchaseCount : 0 , currGJGGLPurchaseCount:0,currSuperGGLPurchaseCount:0 ,currNewGGLPurchaseCount : 0};
            this.mGameLayer.writeGameData();
        }
        this.initData();
        this.refreshBtn();
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.BLM, this.node);

        this.touchNode.on(cc.Node.EventType.TOUCH_END, this.onTouchEnd,this);
    }

    bindData( lotteryFFCManager : ShopLotteryFFCManager ){
        this.mLotteryFFCManager = lotteryFFCManager;
    }

    /**
     * 初始化 橱柜
     */
    initData(){
        // for ( let chineseZodiac of this.ChineseZodiacArray ) {
        //     // 初始化橱柜
        //     let ambryItemNode = cc.instantiate( this.ambryItemPrefab );
        //     ambryItemNode.getComponent( AmbryItem ).bindData( chineseZodiac );
        //     this.ambryContentNode.addChild( ambryItemNode );
        // }
    }

    resetTouchCount() {
        this.touchCount = 0;
    }

    showTalk(str: string) {
        // this.labelTalk.string = str;

        // this.nodeTalk.height = this.labelTalk.node.height + this.talkSpaceY;
        // this.sprTalkBg.children.forEach((v)=> {
        //     v.getComponent(cc.Widget).updateAlignment();
        // });
        this.touchNode.active = true;
        this.nodeTalk.active = true;
        this.nodeTalk.opacity = 0;
        cc.tween(this.nodeTalk)
        .to(0.2, {opacity: 255})
        .delay(3.5)
        .call(() => {
            this.nodeTalk.active = false;
        })
        .start();
    }

    onTouchEnd(e: cc.Event.EventTouch) {
        let worldPos:cc.Vec2 = e.getLocation();
        let node = e.getCurrentTarget();
        let touchPos = node.convertToNodeSpaceAR(worldPos);

        let box:cc.PolygonCollider = node.getComponent(cc.PolygonCollider);
        let points = box.points;
        touchPos.x -= box.offset.x;
        touchPos.y -= box.offset.y;
        let isTrigger = cc.Intersection.pointInPolygon(touchPos, points);
        if (isTrigger) {
            this.openShipLayer();
        }
    }

    openShipLayer() {
        this.node.destroy();
        
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.ShipListLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ShipListLayer
            , null
            , {

            }
            , null
            , null
            , false
        )
    }

    onClickRole() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        this.touchCount++;
        if (this.touchCount >= 5) {
            this.showTalk('不要动手动脚的嘛!有什么事你说');
            this.touchCount = 0;
        }
    }

    /**
     * 退出
     */
    onBtnExit(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    onClickOpenTouchCard() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ShopTouchCardSelectLayer
        );
        
    }

    /**
     * 打开刮刮乐
     */
    onBtnOpenGGLottery( e , gglCount : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.LotterySelectLayer
        );
            
        // let needPayPrice : number = 20;
        // if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
        //     O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
            
        //     NormalGameManager._instance.openBankPage();
        //     return;
        // }
        // O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
        // NormalGameManager._instance.getGameData().lotteryInfo.currNewGGLPurchaseCount ++;
        // NormalGameManager._instance.writeGameData();
        // this.refreshBtn();

        // let gglPrefabNode = cc.instantiate( this.lotteryGGLPrefab );
        // this.node.addChild( gglPrefabNode );
        // gglPrefabNode.getComponent( ShopLotteryNewGGLPrefab ).bindData(  );
    }
    /**
     * 广告购买
     */
    onBtnOpenFFCLotteryAd(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.refreshBtn();
            let gglPrefabNode = cc.instantiate( this.lotteryGGLPrefab );
            this.node.addChild( gglPrefabNode );
            gglPrefabNode.getComponent( ShopLotteryNewGGLPrefab ).bindData(  );
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"刮刮乐解锁");
    }

    /**
     * 打开分分彩预制体
     * @param e
     */
    onBtnOpenFFCLottery( e ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.mLotteryFFCManager.currBetLotteryNumber.length > 0 ) {
            O1HD.getModules().uiControlModule.showMessageBox("一天只能购买一注哦",this.node);
            return;
        }

        let ffcPrefabNode = cc.instantiate( this.lotteryFFCPrefab );
        this.node.addChild( ffcPrefabNode );
        this.node.getChildByName("btnNode").active = false;
        ffcPrefabNode.getComponent( ShopFFCSimplePrefab ).bindData( this.mLotteryFFCManager );
    }


    refreshBtn(){
        // this.gglAdBtnNode.active = true;
        // let lotteryInfo = NormalGameManager._instance.getGameData().lotteryInfo;
        // if ( lotteryInfo  ) {
        //     if ( lotteryInfo.currNewGGLPurchaseCount >= gameConfig.NEW_GGL_CURR_LIMIT ) {
        //         this.gglAdBtnNode.active = true;
        //     }else{
        //         this.gglAdBtnNode.active = false;
        //     }
        // }else {
        //     this.gglAdBtnNode.active = false;
        // }
    }
    /**
     * 双色球
     */
    onBtnSsq(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let ssqPrefabNode = cc.instantiate( this.lotteryMachinePrefab );
        this.node.addChild( ssqPrefabNode );
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.BLM);
    }

    /**
     * 购买
     * @param needPayPrice 
     * @returns 
     */
    buyLottery(needPayPrice: number) {
        if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
            NormalGameManager._instance.openBankPage();
            return false;
        }
        O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
        return true;
    }

    openLotteryLayer(
        path: FileKind.PrefabFileInfo
        , price: number
    ) {
        
        if (!this.buyLottery(price)) {
            return;
        }
        utilsView.openPopupLayerTwo(
            path
            , this.node
        );
    }
}

